import { useIntl } from 'react-intl';
import { useCreateNewsEntryAttachment } from '~/hooks/api/useCreateNewsEntryAttachment';
import UploadForm from '~/components/UploadForm';

import List from '@mui/material/List';
import messages from './messages';
import AttachmentListItem from './AttachmentListItem';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';

export type Attachment = {
  id: number;
  blobId?: string;
  fileName?: string;
  contentType?: string;
};

type AttachmentsProps = {
  append: (attachment: Attachment) => void;
  fields: Attachment[];
  remove: (index: number) => void;
};

const Attachments = (props: AttachmentsProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const createNewsEntryAttachmentMutation = useCreateNewsEntryAttachment({
    onSuccess(result) {
      props.append({
        id: result.id!,
        blobId: result.blobId || undefined,
        fileName: result.fileName || undefined,
        contentType: result.contentType || '',
      });
      showSnackbar({
        message: intl.formatMessage(messages.attachmentUploadSucceeded),
      });
    },
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.attachmentUploadFailed),
      });
    },
  });
  return (
    <>
      {props.fields.length > 0 ? (
        <List>
          {props.fields.map((field, index) => (
            <AttachmentListItem
              key={field.id}
              attachment={{
                id: field.id,
                fileName: field.fileName,
              }}
              onRemoveAttachment={() => props.remove(index)}
            />
          ))}
        </List>
      ) : null}
      <UploadForm
        onSubmit={({ file }) =>
          createNewsEntryAttachmentMutation.mutate({ file: file[0] })
        }
        label={intl.formatMessage(messages.attachmentUpload)}
      />
    </>
  );
};

export default Attachments;
